export default "__VITE_ASSET__BHjZ6Cb4__"